var _filter, _filter2, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 52,
    viewBox: "0 0 61 52",
    width: 61,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 25.8179,
    width: 26.4395,
    x: 0.925781,
    y: 8.35156
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_714_15982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_15982",
    mode: "normal",
    result: "shape"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "b",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 26.0103,
    width: 27.5566,
    x: 32.8516,
    y: 6.03247
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0941176 0 0 0 0 0.564706 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_714_15982"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_15982",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.5 0h60v51.1111h-60z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.5114 49.7152h-34.7246c-5.10855 0-9.24871-4.14-9.24871-9.2488v-8.9577c0-3.0696 2.48762-5.5573 5.55722-5.5573h42.10989c3.0698 0 5.5574 2.4877 5.5574 5.5573v8.9577c-.0023 5.1065-4.1423 9.2488-9.2512 9.2488z",
    fill: "#91d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.3416 15.8765-2.9894 1.3619c-.1112.0506-.2436.0011-.2942-.1101-.0507-.1112-.0012-.2435.11-.2942l2.9895-1.3618c.1111-.0507.2435-.0012.2941.11.0507.1112.0012.2436-.11.2942z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5857 20.8018-2.9894 1.3619c-.1111.0506-.2435.0011-.2942-.1101-.0506-.1111-.0011-.2435.11-.2942l2.9895-1.3618c.1112-.0507.2436-.0011.2942.11.0506.1112.0011.2436-.1101.2942z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.0132 24.7922-18.27014 8.3229c-.3032.1382-.66009.003-.79729-.2982l-6.965763-15.2908c-.138119-.3032-.002937-.6601.298223-.7973l18.27017-8.32301c.3032-.13813.6601-.00293.7973.29823l6.9658 15.29088c.1381.3031.0029.6601-.2983.7973zm-25.55081-7.6592c-.07883.036-.11404.1301-.07813.2089l6.96573 15.2908c.03592.0789.13009.1141.20889.0782l18.27022-8.323c.0788-.0359.114-.1301.0781-.2089l-6.9657-15.29081c-.0359-.07884-.1301-.11404-.2089-.07813z",
    fill: "#e6f7ff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.0132 24.7922-18.27014 8.3229c-.3032.1382-.66009.003-.79729-.2982l-6.965763-15.2908c-.138119-.3032-.002937-.6601.298223-.7973l18.27017-8.32301c.3032-.13813.6601-.00293.7973.29823l6.9658 15.29088c.1381.3031.0029.6601-.2983.7973zm-25.55081-7.6592c-.07883.036-.11404.1301-.07813.2089l6.96573 15.2908c.03592.0789.13009.1141.20889.0782l18.27022-8.323c.0788-.0359.114-.1301.0781-.2089l-6.9657-15.29081c-.0359-.07884-.1301-.11404-.2089-.07813z",
    fill: "#e6f7ff"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#91d5ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.2523 13.4847-14.24584 6.4897c-.11116.0506-.24356.0011-.2942-.1101-.05064-.1111-.00112-.2435.11005-.2942l14.24579-6.4897c.1112-.0506.2436-.0011.2943.1101.0506.1112.0011.2435-.1101.2942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.43 18.2652-14.24582 6.4897c-.11116.0506-.24356.0011-.29418-.11-.05066-.1112-.00111-.2436.11005-.2943l14.24585-6.4897c.1111-.0506.2435-.0011.2942.1101.0515.1132.0011.2435-.1101.2942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.7771 18.867-7.68079 3.499c-.11115.0506-.24355.0011-.29422-.11-.05062-.1112-.00111-.2436.11005-.2943l7.68076-3.4989c.1112-.0507.2436-.0012.2943.11.0506.1112.0011.2436-.1101.2942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.0212 23.7933-7.68076 3.499c-.11116.0506-.24356.0011-.29418-.1101-.05067-.1112-.00116-.2436.11004-.2942l7.6808-3.499c.1112-.0506.2436-.0011.2942.1101.0506.1111.0011.2435-.1101.2942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.56 27.2134-5.18048 2.36c-.11116.0506-.24356.0011-.29422-.11-.05063-.1112-.00112-.2436.11004-.2942l5.18046-2.36c.1112-.0507.2436-.0012.2943.11.0506.1112.0011.2436-.1101.2942z"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.4079 19.4826 3.2614.3928c.1213.0147.2086.1258.194.2471-.0147.1213-.1258.2086-.2471.194l-3.2615-.3929c-.1213-.0146-.2085-.1258-.1939-.2471s.1258-.2086.2471-.1939z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.0553 14.1083 3.2614.3929c.1213.0146.2086.1258.194.247-.0146.1213-.1258.2086-.2471.194l-3.2614-.3929c-.1213-.0146-.2086-.1258-.194-.2471.0146-.1212.1258-.2085.2471-.1939z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#e6f7ff",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40.9425 6.09102 18.1229 8.63878c.3009.1433.4267.5036.2845.8023l-7.2302 15.1677c-.1432.3007-.5036.4267-.8023.2843l-18.1229-8.6387c-.3008-.1434-.4268-.5036-.2844-.8024l7.2301-15.16763c.1433-.30075.5036-.42675.8023-.28435zm10.566 24.49208c.0783.0373.1729.0037.2103-.0744l7.2302-15.1677c.0369-.0782.0035-.173-.0747-.2102l-18.1229-8.63881c-.0783-.03724-.173-.00369-.2103.07454l-7.23 15.16767c-.0373.0781-.0037.1729.0745.2102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.9425 6.09102 18.1229 8.63878c.3009.1433.4267.5036.2845.8023l-7.2302 15.1677c-.1432.3007-.5036.4267-.8023.2843l-18.1229-8.6387c-.3008-.1434-.4268-.5036-.2844-.8024l7.2301-15.16763c.1433-.30075.5036-.42675.8023-.28435zm10.566 24.49208c.0783.0373.1729.0037.2103-.0744l7.2302-15.1677c.0369-.0782.0035-.173-.0747-.2102l-18.1229-8.63881c-.0783-.03724-.173-.00369-.2103.07454l-7.23 15.16767c-.0373.0781-.0037.1729.0745.2102z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#91d5ff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.2746 19.305 14.1313 6.7359c.1102.0525.1573.1858.1049.2961-.0529.1102-.1858.1574-.2965.1048l-14.1308-6.7359c-.1103-.0525-.1575-.1857-.105-.296.0526-.1103.1858-.1575.2961-.1049z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.5344 14.5636 14.1313 6.7359c.1102.0526.1573.1858.1048.2961-.0528.1102-.1857.1574-.2964.1049l-14.1309-6.7359c-.1103-.0526-.1575-.1858-.1049-.2961.0535-.1123.1858-.1575.2961-.1049z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.9172 20.0376 7.6191 3.6318c.1102.0525.1573.1857.1049.296-.0529.1103-.1858.1575-.2964.1049l-7.6188-3.6317c-.1102-.0526-.1575-.1858-.1049-.2961.0526-.1102.1858-.1574.2961-.1049z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.2462 15.1514 7.6191 3.6317c.1102.0526.1573.1858.1048.2961-.0524.1103-.1857.1575-.296.1049l-7.6191-3.6317c-.1102-.0526-.1573-.1858-.1048-.2961.0524-.1103.1857-.1575.296-.1049z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.8047 14.0696 5.1387 2.4495c.1107.0525.1578.1858.1053.2961-.0528.1103-.1857.1575-.2964.1049l-5.1387-2.4495c-.1102-.0526-.1573-.1858-.1049-.2961.0525-.1103.1858-.1575.296-.1049z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m23.5023 27.873 20.2462 5.8561c.4949.1425 1.0126-.1414 1.1551-.6363l5.8561-20.2463c.1426-.4949-.1414-1.0125-.6365-1.155l-20.2461-5.85613c-.4949-.14249-1.0125.14146-1.155.63635l-5.8562 20.24628c-.1452.4933.141 1.0104.6364 1.155z",
    fill: "#9cd1fa",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.4045 27.2093 19.3262 5.5917c.7492.2177 1.5332-.2148 1.7487-.9633l5.5916-19.3263c.2178-.7491-.2147-1.533-.9631-1.7485l-19.3264-5.59182c-.7492-.21768-1.5331.21485-1.7487.96338l-5.5917 19.32624c-.2177.7491.2148 1.5331.9634 1.7486z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4814 25.4901 18.2851 5.2895 5.2895-18.2851-18.285-5.28942z",
    fill: "#91d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.4283 25.5738-.2115-.0612 2.0982-7.25.0278-.0947 3.3-1.5691c1.1348-.5391 2.5096-.1538 3.1968.8982l3.2359 4.9544c.1238.1901.3587.2704.5732.1953l3.6149-1.2733c.6745-.2382 1.4071.0735 1.7053.723l2.1549 4.6889-1.1979 4.1399zm17.139-3.2931c-.2015-.4407-.7012-.6531-1.159-.4907l-3.6149 1.2733c-.4054.144-.8525-.0088-1.0879-.3693l-3.2359-4.9544c-.5673-.8677-1.702-1.1879-2.6387-.7425l-3.1207 1.4826-1.948 6.7323 17.8632 5.1678 1.0295-3.5601z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.6291 16.9754c-1.2413-.3586-1.9577-1.6601-1.5992-2.9014.3586-1.2413 1.6602-1.9578 2.9015-1.5992 1.2413.3585 1.9578 1.6601 1.5992 2.9014-.2881.9952-1.1821 1.6545-2.1654 1.6894-.2406.0108-.4894-.0176-.7361-.0902zm-1.1762-2.779c-.2917 1.0077.291 2.0643 1.2987 2.356 1.0077.2918 2.0643-.291 2.356-1.2987.2918-1.0076-.291-2.0642-1.2986-2.356-.1991-.0576-.4009-.0823-.5985-.0737-.7959.0313-1.5229.566-1.7576 1.3724z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.3275 27.0205-14.515 2.0989c-.7716.1116-1.4887-.4244-1.6003-1.1959l-2.0989-14.5151c-.1116-.7715.4243-1.4886 1.1959-1.6002l14.5151-2.09893c.7716-.11156 1.4886.42433 1.6002 1.19593l2.0989 14.515c.1097.7741-.4243 1.4887-1.1959 1.6003z",
    fill: "#4c65ba",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.3217 26.2688-14.5151 2.0989c-.7715.1116-1.4886-.4244-1.6002-1.196l-2.0989-14.515c-.1116-.7715.4243-1.4887 1.1959-1.6002l14.515-2.09894c.7716-.11155 1.4887.42436 1.6003 1.19594l2.0989 14.515c.1119.7738-.4244 1.4887-1.1959 1.6003z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.9442 10.4468-14.3612 2.0766 2.0767 14.3612 14.3611-2.0767z",
    fill: "#ff7875",
    opacity: 0.39
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.2787 24.8987-14.7964 2.1396-.4803-3.3215 2.1284-3.3307c.3073-.4821.923-.6474 1.4323-.3844l2.5953 1.3415c.1311.0686.2928.0385.3887-.0742l2.9619-3.4019c.6468-.7421 1.7538-.8932 2.577-.3524l2.3463 1.5436.8446 5.8408zm-14.4267 1.6396 13.926-2.0137-.7537-5.2121-2.1824-1.4349c-.6396-.4192-1.5001-.3015-2.0027.2739l-2.9619 3.4019c-.231.2645-.6109.3374-.9238.1762l-2.5975-1.3412c-.3056-.1578-.6748-.0573-.8574.2317l-2.0407 3.1924z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.5048 17.2644c-1.0024.1449-1.9381-.5524-2.0833-1.557-.1453-1.0046.5523-1.9381 1.5569-2.0834 1.0024-.1449 1.9381.5524 2.0834 1.557.1452 1.0046-.5546 1.9384-1.557 2.0834zm-.4631-3.2029c-.7628.1103-1.2931.8198-1.1828 1.5826s.8199 1.2931 1.5827 1.1828 1.293-.8199 1.1827-1.5826c-.1103-.7628-.8198-1.2931-1.5826-1.1828z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.7791 30.8929-9.4725 3.5499c-.8723.3261-1.8426-.114-2.1687-.9862l-3.54988-9.4726c-.32608-.8722.114-1.8425.98623-2.1686l9.47255-3.5499c.8722-.3261 1.8426.114 2.1686.9862l3.5499 9.4726c.3261.8722-.1166 1.8425-.9862 2.1686z",
    fill: "#4c65ba",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.8963 30.4928-9.4726 3.5499c-.8722.326-1.8425-.114-2.1686-.9863l-3.54989-9.4725c-.32609-.8723.114-1.8426.98622-2.1687l9.47257-3.5498c.8722-.3261 1.8425.114 2.1686.9862l3.5499 9.4725c.3288.8722-.114 1.8426-.9862 2.1687z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0651 18.7539-10.47623 3.9258 3.92583 10.4763 10.4763-3.9258z",
    fill: "#ffbb96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.3483 33.4225-.9518-2.5425 1.0684-2.8924c.1697-.4586.6548-.7105 1.1267-.5832l2.1766.5832c.069.0186.1406-.0132.175-.0742l1.6729-3.0488c.3871-.7052 1.246-1.0207 1.9989-.7317l2.06.7926 1.6437 4.3904zm-.3924-2.5451.6999 1.869 9.9842-3.7407-1.3786-3.6772-1.8399-.7078c-.5063-.1962-1.087.0185-1.3494.4931l-1.6729 3.0488c-.1511.2757-.4692.4109-.7715.3314l-2.1766-.5833c-.2094-.0556-.4215.0557-.4984.2572z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5898 24.9682c-.6124 0-1.1904-.3738-1.4157-.9809-.2916-.7795.1034-1.6517.8855-1.9433.7794-.2917 1.6516.1034 1.9433.8855.2916.7794-.1034 1.6516-.8855 1.9432-.1723.0663-.35.0955-.5276.0955zm-.0026-2.4947c-.114 0-.2307.0212-.3447.0636-.509.1909-.7662.7582-.5753 1.2672.1909.5091.7582.7662 1.2672.578.5091-.1909.7662-.7582.5754-1.2672-.1458-.3977-.5223-.6416-.9226-.6416z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.02 32.4587-9.4327 3.6541c-.8686.3357-1.8437-.0937-2.1794-.9623l-3.6541-9.4328c-.3357-.8686.0937-1.8437.9623-2.1794l9.4328-3.6541c.8685-.3357 1.8436.0937 2.1796.9623l3.6538 9.4328c.336.8686-.096 1.8437-.9623 2.1794z",
    fill: "#4c65ba",
    opacity: 0.36
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.1334 32.0681-9.4328 3.654c-.8686.3357-1.8437-.0936-2.1794-.9622l-3.6541-9.4329c-.3357-.8685.0937-1.8437.9623-2.1793l9.4329-3.6541c.8684-.3357 1.8435.0937 2.1795.9622l3.6538 9.4329c.3382.8685-.0938 1.8437-.9622 2.1794z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.1727 20.3713-10.4325 4.0411 4.0411 10.4324 10.4323-4.0411z",
    fill: "#d9f7be"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.6174 35.1137-.9797-2.5318 1.0365-2.904c.1646-.4605.6469-.7177 1.1202-.5956l2.1829.5592c.0692.0178.1404-.0148.1741-.0762l1.6392-3.067c.3793-.7095 1.2348-1.0344 1.9908-.7538l2.0685.77 1.692 4.3719zm-.4204-2.5406.7205 1.8612 9.9426-3.8506-1.4191-3.6617-1.8476-.6876c-.5089-.1905-1.0866.0306-1.344.508l-1.6392 3.0671c-.1481.2773-.4647.4161-.7678.3399l-2.1829-.5593c-.21-.0533-.4209.0603-.4955.2627z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.7666 26.6241c-.6124.0067-1.1944-.3607-1.4264-.9653-.3002-.7761.0852-1.6527.864-1.9529.7762-.3002 1.6527.0852 1.9529.864.3002.7762-.0852 1.6527-.864 1.9529-.1716.0682-.3489.0993-.5265.1013zm-.0301-2.4946c-.114.0013-.2304.0238-.3439.0675-.5069.1965-.7578.7666-.5614 1.2735.1965.5069.7667.7578 1.2736.5639.5069-.1965.7578-.7666.5613-1.2735-.1502-.396-.5293-.6358-.9296-.6314z",
    fill: "#fff",
    opacity: 0.47
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.1489 48.1982c7.7625 0 14.0552-6.2929 14.0552-14.0554 0-7.7624-6.2927-14.0552-14.0552-14.0552-7.7624 0-14.0551 6.2928-14.0551 14.0552 0 7.7625 6.2927 14.0554 14.0551 14.0554z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.1783 49.6568h-36.0598c-4.73986 0-8.58237-3.8422-8.58237-8.5822v-2.8231c0-4.7398 3.84251-8.5823 8.58237-8.5823h36.0598c4.74 0 8.5823 3.8425 8.5823 8.5823v2.8231c0 4.74-3.8423 8.5822-8.5823 8.5822z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.0863 41.1356c5.4888-5.4889 5.4888-14.388 0-19.8769-5.4889-5.4888-14.388-5.4888-19.8769 0-5.4888 5.4889-5.4888 14.388 0 19.8769 5.4889 5.4889 14.388 5.4889 19.8769 0z",
    fill: "#1890ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8623 33.2893c-.1665 0-.3354-.0644-.462-.1933-.2509-.2554-.2465-.6641.0089-.9151l3.7714-3.707 3.7116 3.7114c.2532.2532.2532.662 0 .9152-.2533.2532-.662.2532-.9152 0l-2.8052-2.8053-2.8586 2.8097c-.1244.1222-.2865.1844-.4509.1844z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.1492 38.4312c-.3576 0-.6463-.2887-.6463-.6463v-8.4025c0-.3576.2887-.6463.6463-.6463s.6464.2887.6464.6463v8.4025c0 .3576-.2888.6463-.6464.6463z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.2598 42.423h-12.3205c-.884 0-1.6014-.7196-1.6014-1.6014v-4.4755c0-.3576.2887-.6464.6463-.6464s.6464.2888.6464.6464v4.4755c0 .171.1377.3087.3087.3087h12.3205c.2243 0 .4042-.1821.4042-.4042v-4.38c0-.3576.2888-.6464.6464-.6464s.6463.2888.6463.6464v4.38c.0023.9351-.7596 1.6969-1.6969 1.6969z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.6b67124cc087a2b0b2b790ce366fd2f6.svg";
export { ForwardRef as ReactComponent };